import React from "react";
import { EcomotoChatType } from "../../types";
import {
  format,
  isToday,
  isYesterday,
  isThisWeek,
  isThisMonth,
} from "date-fns";

type ChatDetailsProps = {
  chat: EcomotoChatType;
  isExpanded: boolean;
  currentUser?: any;
  setIsExpanded?: React.Dispatch<React.SetStateAction<boolean>>;
  userId: any;
  prevDate?: string;
};
const ChatDetails: React.FC<ChatDetailsProps> = ({
  chat,
  isExpanded,
  setIsExpanded,
  currentUser,
  prevDate,
}) => {
  const maxLength = 400;

  const handleExpandToggle = () => {
    if (setIsExpanded) {
      setIsExpanded((prevExpanded) => !prevExpanded);
    }
  };
  const date = chat?.timestamp
    ? new Date(
        (chat?.timestamp.seconds ?? 0) * 1000 +
          (chat?.timestamp.nanoseconds ?? 0) / 1e6
      )
    : new Date();

  const currentTime = format(date, "h:mm a"); // Format the time

  let formattedDate;

  if (isToday(date)) {
    formattedDate = "Today";
  } else if (isYesterday(date)) {
    formattedDate = "Yesterday";
  } else if (isThisWeek(date)) {
    formattedDate = format(date, "iiii"); // Display the day name (Monday, Tuesday, etc.)
  } else if (isThisMonth(date)) {
    formattedDate = format(date, "d MMMM"); // Display date with month (e.g., 5 February)
  } else {
    formattedDate = format(date, "d MMMM yyyy"); // Display date with month and year (e.g., 5 February 2023)
  }

  const isDifferentDate = prevDate !== formattedDate;
  return (
    <>
      {isDifferentDate && (
        <div className="flex justify-center">
          <span className="px-2 py-1 bg-[#182229] text-[#aebac1] font-light rounded-md text-[9px] font-Poppins">
            {formattedDate}
          </span>
        </div>
      )}
      <div
        className={`relative flex w-full py-1 ${
          currentUser === chat.senderID ? "justify-end" : "justify-start"
        }`}
        key={chat.id}
      >
        <p
          className={`p-3 ${
            currentUser === chat.senderID ? "sent" : "receive"
          }`}
        >
          {chat.text && chat.text.length <= maxLength
            ? chat.text
            : isExpanded
            ? chat.text
            : chat.text?.slice(0, maxLength)}
          {chat.text && chat.text.length > maxLength && (
            <span
              className="cursor-pointer font-extralight text-[10px] pl-2 font-SegoeUI text-greyText"
              onClick={handleExpandToggle}
            >
              {!isExpanded ? "... Read more" : "... See less"}
            </span>
          )}
          <br />
          <span
            className={`block pt-[5px] text-[9.9px] opacity-50 ${
              currentUser === chat.senderID ? "text-[#FFFFFF99]" : "text-black"
            }`}
          >
            {currentTime}
          </span>
        </p>
      </div>
    </>
  );
};

export default ChatDetails;
